import { TaskType } from '@/services/tasks/task.types';
import { useGetTaskIcon } from '@/services/tasks/useTasks';
import { FC, ReactNode } from 'react';

interface TaskChitProps {
  task: TaskType;
  children?: ReactNode;
}

const TaskChit: FC<TaskChitProps> = ({ task, children }) => {
  const getTaskIcon = useGetTaskIcon();
  const Icon = getTaskIcon(task.id);

  return (
    <div
      className="p-2 border rounded-md flex flex-row space-x-3 items-center"
      style={{ backgroundColor: task.color, color: task.textColor }}
    >
      {Icon && <Icon className="w-5 h-5 shrink-0" />}
      <p className="text-sm font-semibold">{task.displayName}</p>
      {children}
    </div>
  );
};

export default TaskChit;
